import { Center, Heading, Link, Stack, Text } from "@chakra-ui/react";
import { Link as RLink, useSearchParams } from "react-router-dom";

import Page from "components/Page";
import SingleCustomerSelectionCheck from "components/SingleCustomerSelectionCheck";
import { contractsPath } from "constants/paths";
import RequestContractForm from "forms/RequestContractForm";
import { ChevronBackArrow } from "icons";
import { mobileStyleBreakpoint } from "util/styleHelpers";

const LAYOUT_SPACING = mobileStyleBreakpoint(4, 10);

const RequestContractPage = () => {
  const [search] = useSearchParams();

  return (
    <Page overflow="hidden">
      <Stack spacing={LAYOUT_SPACING}>
        <Link
          as={RLink}
          to={`/${contractsPath}?${search}`}
          color="navy.600"
          width="fit-content"
          textStyle="cta"
          paddingTop={4}
        >
          <ChevronBackArrow color="navy.600" /> Back to Contracts List
        </Link>
        <SingleCustomerSelectionCheck actionDescription="request a contract">
          <Center>
            <Stack spacing={6} w="100%" maxW="1000px">
              <Heading>
                <Stack spacing={2}>
                  <Text textStyle="h2">Contract Request</Text>
                  <Text fontWeight="normal" textStyle="body">
                    Don’t see the product you are looking for? Try selecting a
                    different customer code.
                  </Text>
                </Stack>
              </Heading>
              <RequestContractForm />
            </Stack>
          </Center>
        </SingleCustomerSelectionCheck>
      </Stack>
    </Page>
  );
};
export default RequestContractPage;
